import apiInlandPrices from '../../api/apiInlandPrices'

const state = {
    prices: [],
    selectedPrice: {},
    isLoading: false,
    newPricePlan: {
        lot_start: null,
        lot_end: null,
        auction: null,
        yokohama: null,
        yokohama_sales: null,
        osaka: null,
        osaka_sales: null,
        nagoya: null,
        nagoya_sales: null,
        kobe: null,
        kobe_sales: null,
        hakata: null,
        hakata_sales: null,
        company: null
    }
}

const getters = {
    getInlandPrices: (state) => {
        return state.prices
    },
    getSelectedInlandPrice: (state) => {
        return state.selectedPrice
    },
    getInlandPriceLoadingStatus: (state) => {
        return state.isLoading
    },
    getNewInlandPricePlan: (state) => {
        return state.newPricePlan
    }
}

const mutations = {
    changeInlandPrices: (state, newValue) => {
        state.prices = newValue
    },
    changeSelectedInlandPriceFieldValue: (state, priceInput) => {
        state.selectedPrice[priceInput.field] = priceInput.value
    },
    changeNewInlandPriceFieldValue: (state, priceInput) => {
        state.newPricePlan[priceInput.field] = priceInput.value
    },
    changeSelectedInlandPricePlan: (state, newValue) => {
        state.selectedPrice = newValue
    },
    changeInlandPricesLoadingStatus: (state, newValue) => {
        state.isLoading = newValue
    },
    changeNewPriceToDefault: (state) => {
        Object.keys(state.newPricePlan).forEach(k => state.newPricePlan[k] = null);
    }
}

const actions = {
    setInlandPriceFieldValue: ({ commit }, priceInput) => {
        commit('changeSelectedInlandPriceFieldValue', priceInput)
    },
    setNewInlandPriceFieldValue: ({ commit }, priceInput) => {
        commit('changeNewInlandPriceFieldValue', priceInput)
    },
    setNewInlandPricePlanToDefault: ({ commit }) => {
        commit('changeNewPriceToDefault')
    },
    setSelectedInlandPricePlan: ({ commit }, newValue) => {
        commit('changeSelectedInlandPricePlan', newValue)
    },
    fetchAllInlandPrices: ({ commit }) => {
        apiInlandPrices
            .inlandPricesListRequest()
            .then((response) => {
                commit('changeInlandPrices', response.data)
            })
    },
    updateInlandPrice: ({ commit, getters, dispatch }) => {
        commit('changeInlandPricesLoadingStatus', true)
        apiInlandPrices
            .updateInlandPriceRequest(getters.getSelectedInlandPrice)
            .then((response) => {
                commit('changeInlandPricesLoadingStatus', false)
                dispatch('setSelectedInlandPricePlan', {})
                dispatch('fetchAllInlandPrices')
            })
            .catch((error) => {
                commit('changeInlandPricesLoadingStatus', false)
                dispatch('setSelectedInlandPricePlan', {})
            })
    },
    storeNewInlandPrice: ({ commit, getters, dispatch }) => {
        commit('changeInlandPricesLoadingStatus', true)
        apiInlandPrices
            .storeInlandPriceRequest(getters.getNewInlandPricePlan)
            .then((response) => {
                commit('changeInlandPricesLoadingStatus', false)
                commit('changeNewPriceToDefault')
                dispatch('fetchAllInlandPrices')
            })
            .catch((error) => {
                commit('changeInlandPricesLoadingStatus', false)
            })
    }
}

export default {
    state,
    getters,
    actions,
    mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/inlandPrices.js